export default {"src":"/_next/static/media/logo-ifp-footer.f7f94742.svg","height":1114,"width":2739,"blurWidth":0,"blurHeight":0};